import React, { useEffect, useState } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import PerguntaModal from './modals/Pergunta';

import { FaPlus, FaEdit, FaFilter } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const Perguntas = () => {
  const [error, setError] = useState(null);

  const [perguntas, setPerguntas] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');

  const [selectedPergunta, setSelectedPergunta] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchPerguntas = async (currentPage) => {
    Swal.fire({
      title: 'Carregando...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await api.get(`/anamnese-perguntas?page=${currentPage}&limit=${limit}&ds_enunciado=${filtroNome}`);

      setPerguntas(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de perguntas.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchPerguntas(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddPergunta = () => {
    setSelectedPergunta(null);
    setIsModalOpen(true);
  };

  const handleEditPergunta = (pergunta) => {
    setSelectedPergunta(pergunta);
    setIsModalOpen(true);
  };

  const handleDeletePergunta = (pergunta) => {
    Swal.fire({
      title: 'Aviso',
      text: 'Deseja deletar a pergunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, confirmar!',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/anamnese-perguntas/${pergunta.id}`);

          fetchPerguntas(currentPage);
          Swal.fire('Sucesso', 'Pergunta deletada com sucesso!', 'success');
        }
        catch (error) {
          Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
      }
    });
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchPerguntas(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
  };

  function tipoPerguntaLabel(tipo) {
    switch (tipo) {
      case '01': return 'Texto';
      case '02': return 'Múltipla Escolha';
      case '03': return 'Escolha Única';
      case '04': return 'Caixa de Seleção';
      case '05': return 'Área de Texto';
      case '06': return 'Arquivo';
      case '07': return 'Faixa de Valores';
    }
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Perguntas x Respostas</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddPergunta}>
                <FaPlus /> Adicionar Pergunta
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-12">
              <label className="form-label fw-bold">Enunciado</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o enunciado da pergunta"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-8 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>


          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Enunciado</th>
                    <th>Tipo</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {perguntas.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center">
                        Nenhuma pergunta encontrada.
                      </td>
                    </tr>
                  ) : (
                    perguntas.map((pergunta) => (
                      <tr key={pergunta.id}>
                        <td className="text-nowrap">{pergunta.ds_enunciado}</td>
                        <td className="text-nowrap">{tipoPerguntaLabel(pergunta.tp_pergunta)}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditPergunta(pergunta)}
                          >
                            <FaEdit />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {isModalOpen && (
          <PerguntaModal
            pergunta={selectedPergunta}
            onClose={() => setIsModalOpen(false)}
            onPerguntaAtualizada={() => fetchPerguntas(currentPage)}
          />
        )}
      </div>
      <div style={{ height: '50px' }}></div>
    </div>
  );
};

export default Perguntas;
